import _toConsumableArray from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import styled, { css } from "styled-components";
import Select from "../Select";
import Stack from "../Stack";
import ButtonLink from "../Button";
import defaultTheme from "../defaultTheme";
import Translate from "../Translate";
var StyledNavigation = styled.div.withConfig({
  displayName: "SkipNavigation__StyledNavigation",
  componentId: "sc-13g9jxq-0"
})(["background-color:", ";padding:", ";width:100%;box-sizing:border-box;&:focus{outline:none;}", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.orbit.paletteCloudLight;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.orbit.spaceMedium;
}, function (_ref3) {
  var show = _ref3.show;
  return !show && css(["clip:rect(1px,1px,1px,1px);overflow:hidden;position:absolute;pointer-events:none;opacity:0;width:0;"]);
});
StyledNavigation.defaultProps = {
  theme: defaultTheme
};
var StyledSelectWrapper = styled.div.withConfig({
  displayName: "SkipNavigation__StyledSelectWrapper",
  componentId: "sc-13g9jxq-1"
})(["max-width:800px;"]);

var SkipNavigation = function SkipNavigation(_ref4) {
  var actions = _ref4.actions,
      feedbackUrl = _ref4.feedbackUrl;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      links = _useState2[0],
      setLinks = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      mappedLinks = _useState4[0],
      setMappedLinks = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      innerPages = _useState6[0],
      setPages = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      show = _useState8[0],
      setShow = _useState8[1];

  var handleLinksClick = function handleLinksClick(ev) {
    var index = Number(ev.target.value);
    var selected = links[index - 1];

    if (selected) {
      selected.setAttribute("tabindex", "-1");
      selected.focus();
    }
  };

  var handlePageClick = function handlePageClick(ev) {
    if (actions) {
      var index = Number(ev.target.value);
      var selected = actions[index - 1];

      if (selected.onClick) {
        selected.onClick();
      } else if (selected.link) {
        window.location.href = selected.link;
      }
    }
  };

  var handleFocus = function handleFocus() {
    if (links.length === 0) {
      var selectedLinks = document.querySelectorAll("[data-a11y-section]");
      var mappedSections = [{
        value: 0,
        label: "Jump to section" // TODO: Dictionary

      }].concat(_toConsumableArray(Object.keys(selectedLinks).map(function (key) {
        return {
          value: Number(key) + 1,
          label: selectedLinks[Number(key)].innerText
        };
      })));

      if (selectedLinks) {
        setLinks(selectedLinks);
      }

      setMappedLinks(mappedSections);

      if (actions) {
        var mappedPages = [{
          value: 0,
          label: "Common actions" // TODO: Dictionary

        }].concat(_toConsumableArray(actions.map(function (el, i) {
          return {
            value: i + 1,
            label: el.name
          };
        })));
        setPages(mappedPages);
      }
    }

    setShow(true);
  };

  return React.createElement(StyledNavigation, {
    tabIndex: "-1",
    onFocus: handleFocus,
    onBlur: function onBlur() {
      setShow(false);
    },
    show: show
  }, React.createElement(Stack, {
    justify: "between"
  }, React.createElement(StyledSelectWrapper, null, React.createElement(Stack, {
    align: "center"
  }, React.createElement(Select, {
    options: mappedLinks,
    onChange: handleLinksClick,
    size: "small"
  }), innerPages.length > 0 && React.createElement(Select, {
    options: innerPages,
    onChange: handlePageClick,
    size: "small"
  }))), feedbackUrl && React.createElement(ButtonLink, {
    href: feedbackUrl,
    type: "secondary",
    external: true,
    size: "small"
  }, React.createElement(Translate, {
    tKey: "a11ymenu_send_feedback"
  }))));
};

export default SkipNavigation;